// extracted by mini-css-extract-plugin
export default {"button":"Button_button__42aPO","white":"Button_white__1xPCc"};